import type { LineItem } from "@commercetools/platform-sdk";
import { type EcommerceItem, getEcommerceItem } from "../use-gtm-variables";

interface RemoveFromCartCheckoutEventData {
	ecommerce: {
		remove: {
			products: EcommerceItem[];
		};
	};
}

export const getData = (
	lineItem: LineItem,
): RemoveFromCartCheckoutEventData => {
	return {
		ecommerce: {
			remove: {
				products: [getEcommerceItem(lineItem)],
			},
		},
	};
};
